import { focusOnElement, getHTMLElementFromRoot } from "@phn/utility/helper";
import { focusTimeout } from "@phn/utility/constants/timeouts";

export function focusOnBurgerButton(): void {
  setTimeout(() => {
    focusOnElement(
      getHTMLElementFromRoot("phn-burger-button phn-p-button-pure"),
    );
  }, focusTimeout);
}
